// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';
import { Tooltip } from 'react-leaflet';
import { monitoringVehicleStatusesEnum } from '../../../lib/enum';

export const Wrapper = styled.div.withConfig({ displayName: "styles__Wrapper", componentId: "sc-10e8fsz-0" })(["width:100%;height:100%;& .vehicle-marker{outline:none;}"]);







export const VehicleMarkerWrapper = styled(
  ({ direction, active, ...props }) => <div {...props} />
).withConfig({ displayName: "styles__VehicleMarkerWrapper", componentId: "sc-10e8fsz-1" })(["border-radius:50%;background:white;width:22px;height:22px;display:flex;align-items:center;justify-content:center;position:relative;", ";", ";"],








(props) =>
props.direction &&
css(["transform:rotate(", "deg);"],
props.direction),

(props) =>
props.active &&
css(["width:26px;height:26px;"]));





export const VehicleMarkerArrow = styled.div.withConfig({ displayName: "styles__VehicleMarkerArrow", componentId: "sc-10e8fsz-2" })(["position:absolute;transform:translate(0,-19px);width:0;height:0;border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid white;&::before{content:'';display:block;width:0;transform:translate(-5px,1px);height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-bottom:5px solid #2770ff;}"]);



















export const VehicleMarker = styled(({ direction, status, ...props }) =>
<VehicleMarkerWrapper active={props.active} direction={direction}>
    <div {...props} />
    {props.active && <VehicleMarkerArrow />}
  </VehicleMarkerWrapper>
).withConfig({ displayName: "styles__VehicleMarker", componentId: "sc-10e8fsz-3" })(["border-radius:50%;width:6px;height:6px;padding:4px;background:white;border:6px solid;", ";", " ", " ", ""],






(props) =>
props.active &&
css(["width:10px;height:10px;border:8px solid;border-color:#2770ff;position:relative;"]),






(props) =>
props.status === monitoringVehicleStatusesEnum.active &&
css(["border-color:#2770ff;"]),


(props) =>
props.status === monitoringVehicleStatusesEnum.nonactive &&
css(["border-color:red;"]),


(props) =>
props.status === monitoringVehicleStatusesEnum.nosignal &&
css(["border-color:orange;"]));




export const BoundaryPoint = styled.div.withConfig({ displayName: "styles__BoundaryPoint", componentId: "sc-10e8fsz-4" })(["width:10px;height:10px;border-radius:50%;border:2px solid;box-sizing:border-box;background:white;"]);








export const StartPoint = styled(BoundaryPoint).withConfig({ displayName: "styles__StartPoint", componentId: "sc-10e8fsz-5" })(["border-color:#f2994a;"]);



export const EndPoint = styled(BoundaryPoint).withConfig({ displayName: "styles__EndPoint", componentId: "sc-10e8fsz-6" })(["border-color:#27ae60;"]);



export const VehicleTooltip = styled(Tooltip).withConfig({ displayName: "styles__VehicleTooltip", componentId: "sc-10e8fsz-7" })(["box-shadow:none;font-size:10px;font-family:inherit;font-weight:bold;border-radius:5px;padding:9px;&::before{display:none;}"]);
